import { useSelector } from 'react-redux';

import { useProductTour } from '@edu-frontend/modules/src/features/productTour';
import { getProductTour } from 'platform-components/src/components/app-factory/selectors';

interface Props {
    name: ProductTourName;
}

export function useBunkerProductTour({ name }: Props) {
    const productTour = useSelector((_) => getProductTour(_, name));
    return useProductTour<ProductTourName>({ productTour, name });
}

// ключи product-tours
export type ProductTourName = 'teacher-onboarding';
